import { Component, Input } from '@angular/core';

@Component({
    selector: '[datagrid-row-empty]',
    templateUrl: './datagrid-row-empty.component.html',
    standalone: false
})
export class DatagridRowEmptyComponent {
	@Input() colspan: number;
	@Input() translationKey: string = 'Datagrid.EmptyRow';
}
